import React, { useState, useEffect } from 'react';
import RichTable from '../components/richTable/RichTable.jsx'
import BacktestResults from './BacktestResults';
import Drawer from '@mui/material/Drawer';
import TableHelpers from '../helpers/TableHelpers.js';

function PlanXRay(props) {

    const [originalAllocations, setOriginalAllocations] = useState([]);
    const [allocations, setAllocations] = useState([]);
    const [performance, setPerformance] = useState(null);
    const [chartData, setChartData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showAlgoList, setShowAlgoList] = useState(false)

    useEffect(() => {
        (async function () {
            let allocations = await (await fetch(`/api/algos?planId=` + props.planId + `&years=5`)).json();
            console.log("allocations", allocations);
            if (allocations && allocations.length) {
                allocations.forEach(allocation => allocation.selected = true);
                setOriginalAllocations(allocations)
                setAllocations(allocations)
            }
        })();
    }, [props.planId]);

    function toggleSelected(idalgos) {
        let temp = JSON.parse(JSON.stringify(allocations));

        let allocation = temp.find(a => a.idalgos === Number(idalgos));
        if (allocation) {
            if (allocation.selected) allocation.selected = false;
            else allocation.selected = true;
        }
        setAllocations(temp);
    }

    function toggleAlgoType(algoType, selected) {
        setShowAlgoList(true);
        let temp = JSON.parse(JSON.stringify(allocations));
        temp.forEach(allocation => {
            if (allocation.algo_type === algoType)
                allocation.selected = selected;
        })
        setAllocations(temp);
    }
    function toggleLongShort(short, selected) {
        setShowAlgoList(true);
        let temp = JSON.parse(JSON.stringify(allocations));
        temp.forEach(allocation => {
            if (allocation.short === short)
                allocation.selected = selected;
        })
        setAllocations(temp);
    }
    function toggleSymbol(symbol, selected) {
        setShowAlgoList(true);
        let temp = JSON.parse(JSON.stringify(allocations));
        temp.forEach(allocation => {
            if (allocation.trade_symbol === symbol)
                allocation.selected = selected;
        })
        setAllocations(temp);
    }

    function toggleEntrySpeed(speed, selected) {
        setShowAlgoList(true);
        let temp = JSON.parse(JSON.stringify(allocations));
        temp.forEach(allocation => {
            if (allocation.entry_speed === speed)
                allocation.selected = selected;
        })
        setAllocations(temp);
    }

    function toggleAll(selected) {
        setShowAlgoList(true);
        let temp = JSON.parse(JSON.stringify(allocations));
        temp.forEach(allocation => {
            allocation.selected = selected
        })
        setAllocations(temp);
    }

    function resetAllocations() {
        setAllocations(JSON.parse(JSON.stringify(originalAllocations)));
    }

    function getSelectedCount() {
        return allocations.reduce((accumulator, allocation) => accumulator + (allocation.selected ? 1 : 0), 0)
    }

    function getUniqueSymbols() {
        return [...new Set(allocations.map(alloc => alloc.trade_symbol))].sort();
    }

    function checkboxFormatter(idalgos, row) {

        let allocation = allocations.find(a => a.idalgos === Number(idalgos));
        return (<input type="checkbox" checked={allocation && allocation.selected} onChange={() => toggleSelected(idalgos)} />)
    }
    function allocationFormatter(percentage, row) {
        return <input type='number' value={percentage} style={{ width: "35px" }} onChange={(e) => overrideAllocation(row.idalgos, e.target.value)} />
    }

    function overrideAllocation(idalgos, percentage) {
        let temp = JSON.parse(JSON.stringify(allocations));
        let allocation = temp.find(a => a.idalgos === Number(idalgos));
        if (allocation) {
            allocation.percentage = Number(percentage);
        }
        setAllocations(temp);
    }

    function overrideAllAllocations(percentage) {
        let temp = JSON.parse(JSON.stringify(allocations));
        temp.forEach(allocation => {
            if (allocation.selected) {
                allocation.percentage = Number(percentage);
            }
        })
        setAllocations(temp);
    }

    async function runTest() {
        if (props.planId && allocations && allocations.length) {

            setIsLoading(true);

            let newPayload = {};
            allocations.forEach(alloc => {
                if (alloc.selected) {
                    newPayload[Number(alloc.idalgos)] = Number(alloc.percentage);
                }
            })

            const newBacktestUrl = `/api/backtestRunComplete?planId=` + props.planId +
                "&startDate=" + new Date(2014, 0, 1).toLocaleDateString() +
                "&endDate=" + new Date().toLocaleDateString() +
                "&startAmount=100000" +
                "&activeTradesOnly=0" +
                "&liveTradesOnly=0" +
                "&deleteResults=0" +
                "&allocationStrategyId=4" +
                "&isOfficial=0";
            console.log("Running new test on for plan", newPayload);
            let newResults = await (await fetch(newBacktestUrl, { method: 'POST', body: JSON.stringify(newPayload) })).json();
            console.log("newResults", newResults);

            if (newResults && newResults.dailyResults) {
                const tempChartData = [];//[["Date", "Account Value", "S&P 500"]]
                newResults.dailyResults.forEach(day => tempChartData.push([new Date(day.date), day.total, day.baseline]))
                setChartData(tempChartData)
            }

            setPerformance(newResults);
            setIsLoading(false);
        }
    }

    return (
        <>

            {getSelectedCount()} algos selected<br></br>
            <button class="btn btn-primary" onClick={() => setShowAlgoList(true)} type="button">Select Algos</button>
            <br></br>
            <br></br>

            <Drawer open={showAlgoList} onClose={() => setShowAlgoList(false)}>
                <div>
                    <button className="btn btn-secondary" onClick={() => toggleAll(false)} type="button">Clear All</button>
                    &nbsp;<button className="btn btn-secondary" onClick={() => toggleAll(true)} type="button">Select All</button>
                    &nbsp;<button className="btn btn-secondary" onClick={() => resetAllocations()} type="button">Reset</button>
                    <br></br>
                    <br></br>
                    <button className="btn btn-secondary" onClick={() => toggleAlgoType("Mean Reversion", false)} type="button">Remove Mean Reversion</button>
                    &nbsp;<button className="btn btn-secondary" onClick={() => toggleAlgoType("Trend", false)} type="button">Remove Trend Following</button>
                    &nbsp;<button className="btn btn-secondary" onClick={() => toggleAlgoType("Candlestick", false)} type="button">Remove Candlestick</button>
                    &nbsp;<button className="btn btn-secondary" onClick={() => toggleAlgoType("Momentum", false)} type="button">Remove Momentum</button>
                    &nbsp;<button className="btn btn-secondary" onClick={() => toggleAlgoType("Calendar", false)} type="button">Remove Calendar</button>
                    &nbsp;<button className="btn btn-secondary" onClick={() => toggleAlgoType("Breadth", false)} type="button">Remove Breadth</button>
                    &nbsp;<button className="btn btn-secondary" onClick={() => toggleAlgoType("Intermarket", false)} type="button">Remove Intermarket</button>
                    &nbsp;<button className="btn btn-secondary" onClick={() => toggleAlgoType("Volatility", false)} type="button">Remove Volatility</button>
                    <br></br>
                    <br></br>
                    <button className="btn btn-secondary" onClick={() => toggleLongShort(0, false)} type="button">Remove Long</button>
                    &nbsp;<button className="btn btn-secondary" onClick={() => toggleLongShort(1, false)} type="button">Remove Short</button>
                    <br></br>
                    <br></br>
                    <button className="btn btn-secondary" onClick={() => toggleEntrySpeed("fast", false)} type="button">Remove Fast</button>
                    &nbsp;<button className="btn btn-secondary" onClick={() => toggleEntrySpeed("medium", false)} type="button">Remove Medium</button>
                    &nbsp;<button className="btn btn-secondary" onClick={() => toggleEntrySpeed("slow", false)} type="button">Remove Slow</button>
                    <br></br>
                    <br></br>
                    {getUniqueSymbols().map(sym => <>&nbsp;<button className="btn btn-secondary" onClick={() => toggleSymbol(sym, false)} type="button">Remove {sym}</button></>)}
                    <br></br>
                    <br></br>
                    Allocation Override: <input type='number' placeholder='default percentage' onChange={(e) => overrideAllAllocations(e.target.value)} />
                    <br></br>
                    <br></br>
                    <button className="btn btn-secondary" onClick={() => setShowAlgoList(false)} type="button">Close</button>

                    <div style={{ padding: "20px" }}>
                        <RichTable data={allocations} mappers={[
                            { title: 'Include', field: 'idalgos', formatter: checkboxFormatter },
                            { title: 'Allocation', field: 'percentage', formatter: allocationFormatter },
                            { title: 'Algo', field: 'display_name' },
                            { title: 'Symbol', field: 'trade_symbol' },
                            { title: 'Type', field: 'algo_type' },
                            { title: 'Short', field: 'short', formatter: TableHelpers.boolFormatter },
                            { title: 'Entry Speed', field: 'entry_speed' },
                        ]} className="table-striped table-hover table-condensed" />
                    </div>
                </div>
            </Drawer>


            <button class="btn btn-primary" onClick={() => runTest()} type="button">Run</button>

            {isLoading || (performance && performance.dailyResults && performance.dailyResults.length) ?
                <BacktestResults isLoading={isLoading} mobileView={props.mobileView} planId={props.planId} backtestResults={performance} chartData={chartData} />
                :
                null}
        </>
    );
}

export default PlanXRay;